import actions from './actions'

const featuresReducer = (state = {}, action) => {
  switch (action.type) {
    case actions.setFeatures:
      return { ...state, features: action.features }
    default:
      return state
  }
}

export default featuresReducer



// WEBPACK FOOTER //
// ./src/store/features/reducer.js